import React, { useEffect, useState } from "react";
import { Modal, Button, Navbar, Nav, NavDropdown } from "react-bootstrap";
import "./NavBar.css";
import brand from "../assets/img/brand-nav.png";
import { useDispatch, useSelector } from "react-redux";
import customerActions from "../redux/actions/customerActions";
import cartActions from "../redux/actions/cartActions";
import axios from "axios";

function NavBar() {
  const customer = useSelector((store) => store.customer);
  const cart = useSelector((store) => store.cart);
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);

  try {
    const getCategories = async () => {
      const response = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + "/api/categories",
      });
      setCategories(response.data);
    };

    useEffect(() => {
      getCategories();
    }, []);
  } catch (error) {
    console.log("Error: ", error);
  }

  const handleLogout = () => {
    dispatch(customerActions.deleteCustomer);
    dispatch(cartActions.resetCart);
  };
  return (
    <Navbar
      fixed="top"
      className="bg-white shadow-sm px-2 px-md-4"
      collapseOnSelect
      expand="lg"
      variant="light"
    >
      <Navbar.Brand href="/">
        <img id="brand-nav" src={brand} alt="Premium Teas" />
      </Navbar.Brand>

      <Nav className="d-lg-none d-md-flex flex-row ms-auto me-3">
        {!customer && (
          <>
            <Nav.Link
              className="nav-link d-none d-sm-block my-auto me-3"
              eventKey={2}
              href="/login"
            >
              Login
            </Nav.Link>
            <Nav.Link
              className="nav-link d-none d-sm-block my-auto me-3"
              eventKey={2}
              href="/register"
            >
              Register
            </Nav.Link>
          </>
        )}

        <Nav.Link
          href="/cart"
          className="position-relative d-flex align-items-center"
        >
          <i className="bi bi-cart3 fs-4 me-3"></i>
          <div className="cart-number rounded-circle bg-yellow position-absolute d-flex justify-content-center align-items-center text-white fw-bold f-roboto">
            {cart.reduce((acc, product) => acc + product.qty, 0)}
          </div>
        </Nav.Link>
      </Nav>
      <Navbar.Toggle
        aria-controls="responsive-navbar-nav"
        className="border-0"
      />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="fs-5 f-roboto fw-bold text-black">
          {!customer && (
            <>
              <Nav.Link
                className="nav-link d-sm-none fw-normal my-auto me-3"
                eventKey={2}
                href="/login"
              >
                Login
              </Nav.Link>
              <Nav.Link
                className="nav-link d-sm-none fw-normal my-auto me-3"
                eventKey={2}
                href="/register"
              >
                Register
              </Nav.Link>
            </>
          )}
          <NavDropdown title="Shop By Category" id="collasible-nav-dropdown">
            {categories.length > 0 &&
              categories.map((category) => (
                <NavDropdown.Item
                  key={category.id}
                  className="drop-item fs-5 py-3 border-bottom"
                  href={`/category/${category.slug}`}
                >
                  {category.name}
                </NavDropdown.Item>
              ))}
          </NavDropdown>
          <Nav.Link
            className="mx-lg-2 mx-md-0 text-danger"
            href="/products/sale"
          >
            Sale
          </Nav.Link>
          <Nav.Link className="mx-lg-2 mx-md-0" href="/about-this-project">
            About This Project
          </Nav.Link>
        </Nav>
        <Nav className="d-lg-flex d-block align-items-center ms-lg-auto f-roboto">
          <Nav.Link
            href="/cart"
            className="position-relative d-lg-block cart-lg"
          >
            <i className="bi bi-cart3 fs-4 me-3"></i>
            <div className="cart-number rounded-circle bg-yellow position-absolute d-flex justify-content-center align-items-center text-white fw-bold f-roboto">
              {cart.reduce((acc, product) => acc + product.qty, 0)}
            </div>
          </Nav.Link>
          {customer ? (
            <NavDropdown
              title={customer.firstname}
              id="collasible-nav-dropdown"
              align="end"
              className="account-dropdown"
            >
              <NavDropdown.Item
                className="drop-item fs-5 border-bottom py-3"
                href={`/customers/${customer.firstname.toLowerCase()}/profile`}
              >
                <i className="bi bi-person-circle me-2" />
                Profile
              </NavDropdown.Item>

              <NavDropdown.Item
                className="drop-item fs-5 border-bottom py-3"
                href={`/customers/${customer.firstname.toLowerCase()}/orders`}
              >
                <i className="bi bi-receipt-cutoff me-2" />
                My orders
              </NavDropdown.Item>
              <NavDropdown.Item
                className="drop-item fs-5 border-bottom py-3"
                href={`/customers/${customer.firstname.toLowerCase()}/settings`}
              >
                <i className="bi bi-gear me-2" />
                Settings
              </NavDropdown.Item>
              <NavDropdown.Item
                className="drop-item fs-5 border-bottom py-3 "
                onClick={() => handleLogout()}
              >
                <i className="bi bi-box-arrow-right me-2" />
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          ) : (
            <>
              <Nav.Link
                className="fs-5 d-lg-block account-links"
                eventKey={2}
                href="/login"
              >
                Login
              </Nav.Link>
              <Nav.Link
                className="fs-5 d-lg-block account-links"
                eventKey={2}
                href="/register"
              >
                Register
              </Nav.Link>
            </>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavBar;
